import { render, staticRenderFns } from "./IconVirementLight.vue?vue&type=template&id=9e497f4c&"
import script from "./IconVirementLight.vue?vue&type=script&lang=js&"
export * from "./IconVirementLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports